
export const turboData = {
    jeepTurnSpeed: [1, 3],
    timeOutDataJeepTurn: [850, 250],
    centerJeepney: [1000, 280],
    roundEndTimeout: [2500, 2400],
    gameSpeed: [1, 2]
} 